import React from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { BRAND, punchInButtonSx, punchOutButtonSx } from "../styles/authTheme";

const PunchActionButtons = ({
  punchStatus,
  hasValidEmployee,
  loadingStatus,
  punching,
  onPunchIn,
  onPunchOut,
  compact = false,
  sx = {},
}) => {
  const showPunchIn = hasValidEmployee && punchStatus !== "check_in";
  const showPunchOut = hasValidEmployee && punchStatus === "check_in";
  const canPunch = hasValidEmployee && !punching && !loadingStatus;

  if (!hasValidEmployee && !loadingStatus) {
    return null;
  }

  if (loadingStatus) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 2, ...sx }}>
        <CircularProgress size={28} sx={{ color: BRAND.orange }} />
      </Box>
    );
  }

  if (!showPunchIn && !showPunchOut) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 1, sm: 1.5 }, ...sx }}>
      {showPunchIn && (
        <Button
          fullWidth
          variant="contained"
          disableElevation
          disabled={!canPunch}
          onClick={onPunchIn}
          startIcon={
            punching ? <CircularProgress size={18} color="inherit" /> : <LoginOutlinedIcon />
          }
          sx={{
            ...punchInButtonSx,
            py: compact ? 1.35 : { xs: 1.5, sm: 2 },
            minHeight: compact ? 52 : undefined,
            fontSize: compact ? "1rem" : { xs: "0.95rem", sm: "1.05rem" },
            boxShadow: "0 6px 20px rgba(230,90,0,0.35)",
          }}
        >
          Punch In
        </Button>
      )}

      {showPunchOut && (
        <Button
          fullWidth
          variant="contained"
          disableElevation
          disabled={!canPunch}
          onClick={onPunchOut}
          startIcon={
            punching ? <CircularProgress size={18} color="inherit" /> : <LogoutOutlinedIcon />
          }
          sx={{
            ...punchOutButtonSx,
            py: compact ? 1.35 : { xs: 1.5, sm: 2 },
            minHeight: compact ? 52 : undefined,
            fontSize: compact ? "1rem" : { xs: "0.95rem", sm: "1.05rem" },
            bgcolor: BRAND.navy,
            color: "#fff",
            border: "none",
            boxShadow: "0 6px 20px rgba(26,43,74,0.25)",
            "&:hover": {
              bgcolor: "#152238",
              boxShadow: "0 6px 20px rgba(26,43,74,0.3)",
            },
            "&.Mui-disabled": {
              bgcolor: "#E5E7EB",
              color: BRAND.muted,
            },
          }}
        >
          Punch Out
        </Button>
      )}

      {showPunchOut && (
        <Typography
          variant="caption"
          sx={{
            color: BRAND.muted,
            textAlign: "center",
            display: { xs: "none", sm: "block" },
          }}
        >
          You are checked in — tap above to punch out
        </Typography>
      )}
    </Box>
  );
};

export default PunchActionButtons;
